import type { ParsedUrlQuery } from 'querystring'

export type TopicTabType = 'overview' | 'directory' | 'content'

/**
 * Builds a topic tab URL with preserved keyword and tab-specific sort.
 * Matches Search page behavior: preserve keyword when switching tabs, reset page and filters.
 */
export function getTopicTabUrl(
  basePath: string,
  tab: TopicTabType,
  currentQuery: ParsedUrlQuery,
  contentSortDefault = 'Category_Chronologically',
): string {
  if (tab === 'overview') {
    return basePath
  }

  const params = new URLSearchParams()
  params.set('tab', tab)

  const keyword = currentQuery.keyword
  const keywordStr = keyword
    ? typeof keyword === 'string'
      ? keyword
      : Array.isArray(keyword)
        ? keyword[0] || ''
        : ''
    : ''

  if (keywordStr.trim()) {
    params.set('keyword', keywordStr)
  }

  const hasKeyword = !!keywordStr.trim()
  const sort = hasKeyword ? 'bykeyword' : tab === 'directory' ? 'Default' : contentSortDefault

  params.set('sort', sort)

  const queryString = params.toString()
  return queryString ? `${basePath}?${queryString}` : basePath
}
